import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from '@reach/router'
import App from './app'
import serverData, { init as initServerData } from './utils/server-data'
import { ContextProvider as GriffinContextProvider } from '@paypalcorp/worldready-react'

initServerData()
let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

let basepath = `*${serverData.requestURI}`

ReactDOM.render(
  <GriffinContextProvider locale={serverData.locality.locale}>
    <Router basepath={basepath}>
      <App
        path="*"
        pageName={serverData.pageName}
        pageContent={serverData.pageContent}
        pageGroup={serverData.pgGrpKey}
        fptiData={serverData.fptiData}
      />
    </Router>
  </GriffinContextProvider>,
  root,
)
